module.exports = __webpack_public_path__ + "assets/img/right-layer-2-6737b6bc.png";